<template>
  <DescriptionSection>
    <DescriptionItem
      title="Numery lokomotyw"
      :value="service.locomotives.map((v) => v.sideNumber).join(', ')"
    ></DescriptionItem>
  </DescriptionSection>
</template>

<script>
import DescriptionSection from '@/component/Description/description-section';
import DescriptionItem from '@/component/Description/description-item';

export default {
  name: 'LocomotiveWashingDetails',
  components: {
    DescriptionSection,
    DescriptionItem,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
